import { PersistRules } from 'DataBase/rtk-persist/types'

export const ACCOUNT_DB_STORE = 'account-db'
export const ACCOUNT_CACHE_STORE = 'queries'
export const ACCOUNT_CACHE_VERSION = 1

export const persistRules: PersistRules = {}
